import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PageLoader from '../components/Common/PageLoader';

/**
 * Landing page Entra ID redirects to after a successful (or failed) sign-in.
 *
 * The actual token exchange happens in AuthContext's bootstrap effect (via
 * msalClient.handleRedirectResult).  This component just shows a full-screen
 * branded loader while that runs and navigates to /admin (or back to where
 * the user was) once auth state settles.
 */
export default function SsoCallbackPage() {
  const { loading, canSeeDashboard, consumePostLoginPath } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    const target = consumePostLoginPath() || (canSeeDashboard ? '/admin' : '/');
    navigate(target, { replace: true });
  }, [loading, canSeeDashboard, consumePostLoginPath, navigate]);

  return (
    <PageLoader
      message="Signing you in"
      sub="Finalizing your DeliverHealth credentials and loading your admin dashboard."
    />
  );
}
